import { AiOutlineArrowRight } from "react-icons/ai";
import styles from "./home.module.css";
import { Link } from "react-router-dom";
import image from "../../assets/blooddonor.jpg";
import search from "../../assets/search.jpg";
import contact from "../../assets/contact.jpg";
import heart from "../../assets/heart.jpg";
import hands from "../../assets/hands.jpg";
import work from "../../assets/unsplash_W6yy0wYV-hk.png";
import { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";

const Home = () => {
  useEffect(() => {
    AOS.init();
    window.scrollTo({
      top: 0,
      behaviour: "smooth",
    });
  }, []);

  const [register] = useState(false);
  const handleOpenRegister = () => {
    register(true);
  };
  const cardData = [
    {
      id: 0,
      title: "HOW TO DONATE",
      text: "Donating blood is a safe, simple and rewarding experience that usually takes less than an hour! Donating is easy, and it makes a huge difference in the lives of others.",
    },
    {
      id: 1,
      title: "WHERE TO DONATE",
      text: "We offer two types of locations for donations: donor centers and blood drives. We serve local hospitals within Nigeria.",
    },
  ];

  // blood type array
  const blood = [
    {
      id: 0,
      type: "A",
      uses: "People with blood type A have A antigens on the surface of their red blood cells. They can donate blood to individuals with blood types A and AB, while they can receive blood from individuals with blood types A and O.",
    },
    {
      id: 1,
      type: "AB",
      uses: "People with blood type AB have both A and B antigens on their red blood cells. They are considered universal recipients since they can receive blood from individuals with any blood type (A, B, AB, or O), but they can only donate to those with blood type AB.",
    },
    {
      id: 2,
      type: "B",
      uses: " Individuals with blood type B have B antigens on their red blood cells. They can donate blood to individuals with blood types B and AB, and they can receive blood from individuals with blood types B and O.",
    },
    // { id: 3, type: "B+", uses: "Enlighten the space and gives the effect" },
    {
      id: 3,
      type: "O",
      uses: "Individuals with blood type O do not have A or B antigens on their red blood cells. They are considered universal donors because they can donate blood to individuals with any blood type (A, B, AB, or O), but they can only receive blood from individuals with blood type O.",
    },
    // { id: 5, type: "O+", uses: "Enlighten the space and gives the effect" },
  ];

  // about ribi card array
  const card = [
    {
      text: "Find Blood",
      image: search,
    },
    {
      text: "Get Notified",
      image: contact,
    },
    {
      text: "Save a Life",
      image: hands,
    },
    {
      text: "Be Free",
      image: heart,
    },
  ];
  return (
    <main className="main max-w-[1380px] mx-auto">
      {/* ------------------------  Hero Section Start ------------------------------- */}
      <Helmet>
        <meta charSet="utf-8" />
        <title>Home | RIBI BLOOD</title>
        <link rel="canonical" href="https://ribiblood.com" />
      </Helmet>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:px-8 md:px-8 px-4 lg:py-32 py-12 items-center">
        <div className={styles.heroLeft}>
          <h1
            className={`${styles.bigText} leading-tight`}
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            Learn To{" "}
            <span className="text-[#f6655f]" data-aos="fade-right">
              Donate Blood
            </span>{" "}
          </h1>
          <p
            className={`${styles.smallText} lg:max-w-md my-[20px]`}
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            We believe there are many people in the world who needs to be saved
            and we are here so we can assist.
            <span className="lg:block">
              You can help save a life,{" "}
              <Link to="/auth" className=" text-[#f6655f]">
                Register
              </Link>{" "}
              today.
            </span>
          </p>
          <Link
            to="/need-blood"
            className={`${styles.linkHero} hover:gap-[3px] hover:bg-[#f54b46] hover:text-white`}
            data-aos="zoom-in-right"
            data-aos-duration="1000"
          >
            Find Blood <AiOutlineArrowRight className="ml-2" />
          </Link>
          {/* <div className="max-w-md text-xs">
            <div className="flex items-center gap-x-4 ">
              <div className="flex items-center gap-x-3">
                Donated{" "}
                <p className=" text-white bg-[#f6655f] py-1 px-2 rounded-full">
                  40
                </p>
              </div>
              <div className="flex items-center gap-x-3">
                Requested{" "}
                <p className=" text-white bg-[#f6655f] py-1 px-2 rounded-full">
                  40
                </p>
              </div>
            </div>
          </div> */}
        </div>

        {/* -------------------------------- Hero Right ------------------------------- */}

        <div className={`${styles.heroRightContainer} lg:flex hidden`}>
          <img
            src={image}
            className="w-full rounded-full"
            alt="Ribi homapage display "
          />
        </div>
      </div>
      {/* ------------------------  Hero Section End ------------------------------- */}

      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-8 gap-4 lg:px-8 md:px-8 px-4 py-16  bg-red-50 rounded-2xl">
        <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-8 lg:order-1 order-last">
          {card.map((item, index) => {
            return (
              <div
                key={index}
                className="py-6 px-4 shadow-lg bg-slate-50 rounded-xl"
              >
                <img src={item.image} alt="" className={styles.cardImage} />
                <p className={styles.cardText}>{item.text}</p>
              </div>
            );
          })}
        </div>
        <div className="flex flex-col justify-center py-4 lg:order-last order-1">
          <h4
            className={styles.aboutHeading}
            data-aos="zoom-in-up"
            data-aos-duration="1000"
          >
            About RIBI
          </h4>
          <p style={{ margin: "20px 0" }}>
            RIBI is an intermediary between the Donor, Donee and the Medical
            Center. We are focus on saving life by creating an avenue in which
            blood can be easily donated and lives can be saved.
          </p>
          <p className="">
            We provide the day to day communication between the individual who
            needs the blood and the donor who is ready to donate his/her blood
            to save a life. We are open to different Medical Centers who are
            ready to make this a success in assisting to save human lives by
            establishing a testing center for the Donor and the Donee.
          </p>
          <div style={{ marginTop: "20px" }}>
            <Link
              to="/about-us"
              onClick={handleOpenRegister}
              className={`${styles.linkBlood} hover:bg-red-600`}
              style={{ backgroundColor: "#f6655f" }}
            >
              Learn More <AiOutlineArrowRight className="ml-2" />
            </Link>
          </div>
        </div>
      </div>
      {/* Blood Types */}
      {/* <div className={`${styles.typesContainer} bg-red-50`}> */}
      <div className={`${styles.typesContainer} lg:py-16 py-4  px-4`}>
        <h4
          className={styles.types}
          data-aos="zoom-in-up"
          data-aos-duration="1000"
        >
          Blood Types
        </h4>
        <section className="text-center w-lg lg:px-32 px-8 font-normal">
          It's important to note that blood types are further classified as
          Rh-positive or Rh-negative based on the presence or absence of the Rh
          antigen. For example, a person with blood type A positive (A+) has A
          antigens and the Rh antigen on their red blood cells.
        </section>
        {/* <div className={styles.bloodTypesWrapper}> */}
        <div className="grid lg:py-8 py-6 lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 justify-center items-center gap-8 lg:px-12">
          {blood.map((item) => {
            return (
              <div
                key={item.id}
                className={`${styles.blood} drop-shadow-md`}
                data-aos="flip-left"
              >
                <div className={styles.drop}>
                  <p className={styles.bloodText}>{item.type}</p>
                  {/* <p className="hidden hover:block">{item.uses}</p> */}
                  <p
                    className={`${styles.bloodDetails} bg-red-100 rounded-3xl lg:text-xs sm:text-xs text-sm font-normal px-3 text-left leading-relaxed transition-colors`}
                  >
                    {item.uses}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className={`${styles.objectives} lg:py-8 pb-4 lg:px-20 px-4`}>
        <div className="text-center flex flex-col justify-center items-center">
          <p
            className={`${styles.objctText} max-w-lg capitalize text-black font-bold text-center`}
            data-aos="zoom-in-down"
            data-aos-duration="1000"
          >
            Your donation will save lives.{" "}
          </p>
          <p>
            <span className="text-lg">
              It’s not just an appointment, it’s a commitment to save lives!
            </span>
          </p>
        </div>
        <div
          className={`grid grid-cols-1 gap-4 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 justify-center lg:px-12 lg:max-w-[1000px] mx-auto`}
        >
          {cardData.map(({ id, title, text }) => {
            return (
              <div
                key={id}
                className={`${styles.objectCard} mx-auto my-4 lg:min-w-[400px] w-full rounded-lg`}
              >
                <h6
                  style={{
                    margin: "20px 0",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  {title}
                </h6>
                <p style={{ margin: "15px 0", textAlign: "center" }}>{text}</p>
                <Link
                  to="/about-us"
                  style={{
                    cursor: "pointer",
                    display: "inline-flex",
                    border: "none",
                    background: "transparent",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                  className="hover:text-white hover:font-bold"
                >
                  Learn More <AiOutlineArrowRight className="ml-2" />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
      <div className="lg:py-12 py-8 lg:px-12 px-4 bg-[#fbfbfb]">
        <h4
          className={styles.workText}
          data-aos="zoom-in-up"
          data-aos-duration="1000"
        >
          How it Works
        </h4>
        <div className={styles.workContent}>
          <div className="flex justify-center items-center box-border">
            <img
              src={work}
              alt="A laboratory Scientist"
              className={`w-[100%] h-[100%] object-cover rounded-lg`}
            />
          </div>
          <div className="lg:px-12">
            <p className="my-5 lg:px-4 px-2">
              All you need is to follow the below description and get the
              opportunity to Save a Life
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 lg:gap-6 gap-4">
              <div className="rounded-lg bg-white px-6 py-6 shadow-lg">
                <ul className={`${styles.listImage}`}>
                  <h2 className="font-bold text-2xl">Donor</h2>
                  <li style={{ marginTop: "15px", marginLeft: "12px" }}>
                    First, click on the donate blood button to Register.
                  </li>
                  <li style={{ marginTop: "15px", marginLeft: "12px" }}>
                    Sign up and complete your profile
                  </li>
                  <li style={{ marginTop: "15px ", marginLeft: "12px" }}>
                    Upload required details
                  </li>
                  <li style={{ marginTop: "15px", marginLeft: "12px" }}>
                    View pending request
                  </li>
                  <li style={{ marginTop: "15px", marginLeft: "12px" }}>
                    Interact with onee requesting for blood donation
                  </li>
                </ul>
              </div>
              {/* Donee */}
              <div className=" bg-white px-6 rounded-lg py-6 shadow-lg">
                <ul className={`${styles.listImage}`}>
                  <h2 className="font-bold text-2xl">Donee</h2>
                  <li style={{ marginTop: "15px", marginLeft: "12px" }}>
                    Click on the Need Blood button
                  </li>
                  <li style={{ marginTop: "15px", marginLeft: "12px" }}>
                    Use the search box to search for a Donor with preferred blood type
                  </li>
                  <li style={{ marginTop: "15px ", marginLeft: "12px" }}>
                    Fill the request form to Make Blood Request from the Donor
                  </li>
                  <li style={{ marginTop: "15px", marginLeft: "12px" }}>
                    Get the Donor info
                  </li>
                  <li style={{ marginTop: "15px", marginLeft: "12px" }}>
                    Communicate with the Donor
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
